import {
    getData,
    postData,
    deleteData
} from './Services'

export const getArtModelosPanel = async (artId,searchTerm, page, perPage) => {
    let queryParams = [];
    if (artId) {
        queryParams.push(`art_Id=${encodeURIComponent(artId || '')}`);
    }
    if (searchTerm) {
        queryParams.push(`mod_descripcion=${encodeURIComponent(searchTerm || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';

    return await getData("/articulosmodelos", queryString);
};

export const getArtModeloById = async (id) => {
    const res = await getData(`/articulosmodelos/${id}`)
    return res
}

export const postArtModelo = async (body) => {
    const res = await postData('/articulosmodelos', body)
    return res
}

export const deleteArtModelo = async (id) => {
    const res = await deleteData(`/articulosmodelos/${id}`)
    return res
}